import { useLocation } from "react-router-dom";
import "./DiagnosticComponent.css";
import NavbarAll from "../Navbar/NavbarAll";
import servicesData from "./serviceData";

function DiagnosticComponent() {
  const location = useLocation();
  const data = servicesData[location.pathname];

  if (!data) return <div className="not-found">Service not found.</div>;

  return (
    <>
      <NavbarAll />

     
      {/* <div className="service-banner">
        <img src={data.banner || data.images[0]} alt={data.title} className="banner-image" />
      </div> */}

      <div className="service-detail-container">
        <h1 className="service-title">{data.title}</h1>

        <div className="service-detail-content">
          <div className="service-text">
            {typeof data.description === "string" ? (
              <p>{data.description}</p>
            ) : (
              <div className="service-description">{data.description}</div>
            )}
          </div>

          <div className="service-images">
            {data.images.map((imgSrc, index) => (
              <div key={index} className="image-card">
                <img src={imgSrc} alt={`${data.title} ${index + 1}`} />
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}

export default DiagnosticComponent;
